<template>
    <form
        :class="{ 'mb-5': type !== 'decent' }"
        @submit.prevent="$emit('submitted')"
    >
        <div v-if="type === 'decent'">
            <h3 v-if="$slots.title" :class="{ 'mb-3': !$slots.description }">
                <slot name="title" />
            </h3>
            <p v-if="$slots.description" style="margin-bottom: 1.125rem">
                <slot name="description" />
            </p>

            <card :id="id" :type="type" card-classes="mb-3" class="mb-2">
                <slot name="form" />
                <template v-if="$slots.actions" #footer>
                    <required-fields />
                    <div
                        class="d-flex mt-3 align-items-center justify-content-center"
                        style="gap: 5px"
                    >
                        <slot name="actions" />
                    </div>
                </template>
            </card>
        </div>

        <card v-else :id="id" class="mb-2" header-classes="bg-blue-light">
            <template #header>
                <h5 class="mb-0">
                    <slot name="title"></slot>
                </h5>
                <div class="small text-muted">
                    <slot name="description"></slot>
                </div>
            </template>
            <slot name="form" />
            <template v-if="$slots.actions" #footer>
                <required-fields />
                <div
                    class="d-flex mt-3 align-items-center justify-content-center"
                    style="gap: 5px"
                >
                    <slot name="actions" />
                </div>
            </template>
        </card>
    </form>
</template>

<script setup>
import Card from '@/Components/Card.vue';
import RequiredFields from '@/Components/RequiredFields.vue';

const props = defineProps({
    id: String,
    type: String,
});

const emits = defineEmits(['submitted']);
</script>
